import type { RouteDefinition } from '@solidjs/router'
import Chart from './Chart'
import Chat from './Chat'
import Overview from './Overview'
import RouteContainer from './RouteContainer'

const route: RouteDefinition = {
	path: '/:id',
	component: RouteContainer,
	children: [
		{
			path: '/',
			component: Overview,
		},
		{
			path: '/chat',
			component: Chat,
		},
		{
			path: '/chart',
			component: Chart,
		},
		{
			path: '/journal',
			component: () => <p>journal</p>,
		},
		{
			path: '/analysis',
			component: () => <p>analysis</p>,
		},
	],
}

export default route
